// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2lH9R","box":"WorkspacesBox_box__AWxq2","node":"WorkspacesBox_node__7e3VE"};